module.exports = __webpack_public_path__ + "media/images/abuse-victimization-f7c1d6e33793ecd55cdce85e60461fb8.png";